/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B110010 月次更新
 */
import {
  B110010Find,
  B110010FindResponse,
  B110010Update,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  togetsuYm: string;
  togetsuYmF: string;
  getsujiYmd: string;
  getsujiYmdF: string;
  getsujiKbn: number;
  getsujiKbnHyouji: string;
  getsujiYoyakuKbn: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  togetsuYm: "",
  togetsuYmF: "",
  getsujiYmd: "",
  getsujiYmdF: "",
  getsujiKbn: undefined,
  getsujiKbnHyouji: "",
  getsujiYoyakuKbn: "",
};
// フォーカスIDの設定
const focusId = "B110010";

export const B110010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    // API呼び出し
    B110010Find()
      .then((value) => {
        // セットする
        handleSetShoki(value.data);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });

    focus(1);
  }, []);

  // 初期表示 検索結果を各項目にセット
  const handleSetShoki = (data: B110010FindResponse) => {
    // 現在運用年月
    methods.setValue("togetsuYm", data.togetsuYm);
    methods.setValue("togetsuYmF", data.togetsuYmF);
    // 更新状況
    methods.setValue("getsujiYmd", data.getsujiYmd);
    methods.setValue("getsujiYmdF", data.getsujiYmdF);
    methods.setValue("getsujiKbn", data.getsujiKbn);
    methods.setValue("getsujiKbnHyouji", data.getsujiKbnHyouji);
    // 締区分
    methods.setValue("getsujiYoyakuKbn", "本締め");
  };

  // 実行予約イベント
  const handleExecute = () => {
    // 実行API呼び出し
    B110010Update()
      .then(() => {
        setMsg(getClientMessage("B110010_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="月次更新"
        gridTemplateColumns="6rem 4rem 3rem 5rem 5rem 14rem 3rem 4rem 4rem 3rem "
      >
        <SLabel>現在運用年月</SLabel>
        <SNumberField name="togetsuYmF" code disabled />

        <SLabel gridColumn="4">更新状況</SLabel>
        <SDateField name="getsujiYmdF" disabled />
        <STextField name="getsujiKbnHyouji" disabled />

        <SLabel gridColumn="8">締区分</SLabel>
        <STextField name="getsujiYoyakuKbn" disabled />

        <SText gridColumn="1">　</SText>
        <SNormalButton
          label={labels.buttons.reserveExecution}
          gridRow={3}
          gridColumn={9}
          {...register(1)}
          align="right"
          onClick={handleExecute}
        />
      </SFrame>
    </FormProvider>
  );
};
